
const _ = require('lodash');

const util = require('util');

const FormControllerBase = require('./base');
const EmailbackFormModel = require('./emailback-model');


function EmailbackFormController () {
	FormControllerBase.apply(this, arguments);
}

util.inherits(EmailbackFormController, FormControllerBase);

_.extend(EmailbackFormController.prototype, {
	_modelConstructor: EmailbackFormModel,
	_modalTemplate: require('../templates/emailback.html')(),
	_successModalTemplate: require('../templates/emailback-success.html')(),
	_title: 'Написать письмо нашим сотрудникам',
});

module.exports = EmailbackFormController;

